<template>
	<div>
		<Header></Header>
		<router-view v-if="this.authIsAuthenticated"></router-view>
		<Login v-if="!this.authIsAuthenticated"></Login>
		<img src="~@/assets/images/gradient_load.gif" class="preloader" v-if="loading">
		<Footer></Footer>
	</div>
</template>

<script>
	import Header from './Header'
	import Footer from './Footer'
	import Login from '@/components/login'
	
	import { mapGetters } from 'vuex'
	
	export default {
		name: 'Main',
		components: {
			Header,
			Footer,
			Login
		},
		computed: {
			...mapGetters(['isAuthenticated', 'authStatus', 'userStatus', 'getAuthErrorMessage', 'getUserErrorMessage', 'authIsAuthenticated']),
			loading () {				
				return ( this.authStatus === "success" && this.authIsAuthenticated === false && this.userStatus !== "error" )
			}
		},
	}
</script>

<style lang="scss" scoped>

	@import '../scss/style.scss';
	.hide{
		display: none;
	}
	.preloader {
		position: absolute;
        top: 28%;
        right: 0;
        left: 0;
        margin: 0 auto;	
	}
	
</style>